// import { getTradeUrl } from '@/utils'
import EyeButton from '@/components/EyeButton.vue'
import type { FundingRateSignalResponse } from '@/services/funding-rates-v2-service/types'
import { markRaw } from 'vue'
// import BadgeLink from '@/components/BadgeLink.vue'

export const getFundingRateSignalsTableColumns = () => {
  return [
    {
      field: 'symbol_name',
      width: '120px',
      header: 'table.asset',
      class: 'text-center',
      inner: 'span',
      innerProps: {
        class: 'pit',
      },
    },
    {
      field: 'spread',
      width: '100px',
      header: 'table.fundingSpread',
      class: 'text-center',
      inner: 'span',
      dynamic: true,
      innerPropsGenerator: (v: object) => {
        const data = v as FundingRateSignalResponse
        const myClass = data.spread && data.spread > 0 ? 'success' : 'error'
        return {
          class: `pit digit ${myClass} font-bold`,
        }
      },
    },
    {
      field: 'price_spread',
      width: '100px',
      header: 'table.priceSpread',
      class: 'text-center',
      inner: 'span',
      dynamic: true,
      innerPropsGenerator: (v: object) => {
        const data = v as FundingRateSignalResponse
        const myClass = data.price_spread && data.price_spread > 0 ? 'success' : 'error'
        return {
          class: `pit digit ${myClass} font-bold`,
        }
      },
    },
    {
      field: 'long.exchange_name',
      width: '110px',
      header: 'table.exLong',
      class: 'text-center lg:text-right',
      dynamic: true,
      inner: 'span',
      innerProps: {
        class: 'pit table-asset success',
      },
    },
    {
      field: 'long.funding_rate',
      width: '110px',
      header: 'table.fundingRate',
      class: 'text-center hidden lg:table-cell lg:text-left',
      inner: 'span',
      dynamic: true,
      innerPropsGenerator: (v: object) => {
        const data = v as FundingRateSignalResponse
        const myClass = data.long.funding_rate && data.long.funding_rate > 0 ? 'success' : 'error'
        return {
          class: `pit digit ${myClass} font-bold`,
        }
      },
    },
    {
      field: 'short.exchange_name',
      width: '110px',
      header: 'table.exShort',
      class: 'text-center lg:text-right',
      inner: 'span',
      innerProps: {
        class: 'pit table-asset success',
      },
    },
    {
      field: 'short.funding_rate',
      width: '110px',
      header: 'table.fundingRate',
      class: 'text-center hidden lg:table-cell lg:text-left',
      inner: 'span',
      dynamic: true,
      innerPropsGenerator: (v: object) => {
        const data = v as FundingRateSignalResponse
        const myClass = data.long.funding_rate && data.long.funding_rate > 0 ? 'success' : 'error'
        return {
          class: `pit digit ${myClass} font-bold`,
        }
      },
    },
    {
      field: 'period',
      width: '90px',
      header: 'table.period',
      class: 'text-center hidden lg:table-cell',
      inner: 'span',
      innerProps: {
        class: 'pit table-asset success',
      },
    },
    {
      dynamic: true,
      field: '',
      width: '50px',
      header: '',
      class: 'text-center collapser-class',
      inner: markRaw(EyeButton),
      innerPropsGenerator: (data: object) => {
        const sigData = data as FundingRateSignalResponse
        return {
          name: 'eye',
          params: {
            asset: sigData.symbol_name?.split('/')?.[0]?.toLowerCase() ?? '',
            exBuy: sigData.long?.exchange_name,
            exSell: sigData.short?.exchange_name,
            amount: 200,
            marketType: 'swap',
          },
        }
      },
    },
  ]
}
